import { Button } from 'antd';

export interface ButtonProps {
  /** What background color to use */
  backgroundColor?: string;
  /** How large should the button be? */
  size?: 'small' | 'middle' | 'large';
  /** kind of situation */
  situation?: 'default' | 'focused' | 'answered';
  /** Button contents */
  label: string;
  /** Optional click handler */
  onClick?: () => void;
}

/** Primary UI component for user interaction */
export const RoundButton = ({
  size = 'middle',
  backgroundColor,
  label,
  situation = 'default',
  ...props
}: ButtonProps) => {
  const style = [`font-bold`,`${situation === 'default' ? 'bg-gray-500' : ''}`, `${situation === 'focused' ? 'bg-green-500' : ''}`, `${situation === 'answered' ? 'bg-blue-700' : ''}`].join(' ');
  return (
    <Button
      shape='circle'
      size={size}
      type='primary'
      className={[style].join(' ')}
      style={{ backgroundColor }}
      {...props}
    >
      {label}
    </Button>
  );
};
